import { useEffect, useState } from "react";
import {
  Form,
  Modal,
  DropdownButton,
  Dropdown,
  InputGroup,
} from "react-bootstrap";
import CustomColorPicker from "../CustomColorPicker";
import axios from "axios";
import { NEW_API_URL } from "../../../constants/Globals";
import {
  addStepToSequence,
  addBranchToStep,
} from "../../../services/CollectionsSvc";

export default function AddEditSignUpModal({
  show = true,
  onClose,
  contentFormId,
  sequenceId,
  orderNumber,
  selNetworkId,
  networks,
  isFromAddBranch = false,
  selectedStepId = null,
  }) {
  const networkName = (() => {
    if (!selNetworkId || !networks || !Array.isArray(networks))
      return "";
    const found = networks.find((n) => n.id === parseInt(selNetworkId));
    return found ? found.name : "";
  })();
  const [title, setTitle] = useState(
    networkName ? `Subscribe to ${networkName}` : "Subscribe to"
  );
  const [description, setDescription] = useState("Polls, quizzes, and community");
  const [buttonText, setButtonText] = useState("Sign Up");
  const [titleColor, setTitleColor] = useState("#333333");
  const [titleFontSize, setTitleFontSize] = useState("24px");
  const [descriptionColor, setDescriptionColor] = useState("#333333");
  const [descriptionFontSize, setDescriptionFontSize] = useState("16px");
  const [buttonColor, setButtonColor] = useState("#2F80ED");
  const [buttonFontSize, setButtonFontSize] = useState("16px");
  const [buttonTextColor, setButtonTextColor] = useState("#ffffff");
  const pxOptions = Array.from({ length: 30 }, (_, i) => `${i + 1}px`);
  const [loading, setLoading] = useState(false);
  const kTrans = (s) => s;

  useEffect(() => {
    if (contentFormId > 0) {
      axios
        .get(`${NEW_API_URL}/signup-form/${contentFormId}`)
        .then(({ data }) => {
          const f = data.data;
          setTitle(f.title || (networkName ? `Subscribe to ${networkName}` : "Subscribe to"));
          setDescription(f.description || "Polls, quizzes, and community");
          setButtonText(f.buttonText || "Sign Up");
          if (f.styleTitle) setTitleColor(f.styleTitle.color || titleColor);
          if (f.styleTitle)
            setTitleFontSize(f.styleTitle.fontSize || titleFontSize);
          if (f.styleDescription)
            setDescriptionColor(f.styleDescription.color || descriptionColor);
          if (f.styleDescription)
            setDescriptionFontSize(
              f.styleDescription.fontSize || descriptionFontSize
            );
          if (f.styleButton) setButtonColor(f.styleButton.color || buttonColor);
          if (f.styleButton)
            setButtonFontSize(f.styleButton.fontSize || buttonFontSize);
          if (f.styleButton)
            setButtonTextColor(f.styleButton.textColor || buttonTextColor);
        });
    } else {
      setTitle(networkName ? `Subscribe to ${networkName}` : "Subscribe to");
      setDescription("Polls, quizzes, and community");
      setButtonText("Sign Up");
    }
  }, [contentFormId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // If there is an existing form id, update it; otherwise create new form
      let formId = contentFormId > 0 ? contentFormId : null;
      const payload = {
        clientId: selNetworkId ? parseInt(selNetworkId) : undefined,
        title: title,
        description: description,
        buttonText: buttonText,
        styleTitle: { color: titleColor, fontSize: titleFontSize },
        styleDescription: {
          color: descriptionColor,
          fontSize: descriptionFontSize,
        },
        styleButton: {
          color: buttonColor,
          fontSize: buttonFontSize,
          textColor: buttonTextColor,
        },
      };
      if (formId) {
        await axios.put(`${NEW_API_URL}/signup-form/${formId}`, payload);
      } else {
        const res = await axios.post(`${NEW_API_URL}/signup-form`, payload);
        if (res?.data?.data) {
          formId = res.data.data;
        }
      }

      // If we created a new form and sequenceId provided, attach it as a new sign-up step
      if (formId && sequenceId && !contentFormId) {
        try {
          const payload2 = {
            sequenceId: sequenceId,
            order: orderNumber + 1,
            isBranch: false,
            partType: "sign-up",
            partId: formId,
          };
          const resp = await addStepToSequence(payload2);
          const nextId = resp?.data?.data;
          if (isFromAddBranch && selectedStepId) {
            // add branch to existing selected step
            await addBranchToStep(selectedStepId, {
              branchOption: "sign-up-form-branch",
              nextStepId: nextId,
            });
          }
          setLoading(false);
          onClose(nextId);
          return;
        } catch (error) {
          // Just fall through and close with success
          console.error("Failed to add step with new form", error);
        }
      }

      setLoading(false);
      onClose(true);
    } catch (error) {
      setLoading(false);
      console.error("Error saving sign-up form:", error);
      alert("Failed to save sign-up details. Please try again.");
    }
  };

  return (
    <Modal show={show} onHide={() => onClose(false)} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {contentFormId > 0 ? "Edit a Sign Up page" : "Create a Sign Up page"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} className="common-form sided-form">
          <div className="segment-form-body padding-s">
            <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
              <Form.Group style={{ flex: 4 }}>
                <Form.Label>
                  <b className="text-sm-start">{kTrans("Title")}</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  id="title"
                  name="title"
                  className="w-100"
                  placeholder={kTrans("Add a title")}
                />
              </Form.Group>

              <Form.Group style={{ flex: 1 }}>
                <Form.Label>
                  <b className="text-sm-start">{kTrans("")}&nbsp;</b>
                </Form.Label>
                <InputGroup className="w-100 color-picker-container">
                  <CustomColorPicker
                    color={titleColor}
                    onChange={(newColor) => setTitleColor(newColor)}
                  />
                  <Form.Control
                    type="text"
                    value={titleColor}
                    style={{
                      border: "0px solid #ced4da",
                      borderRadius: "0 0.25rem 0.25rem 0",
                    }}
                    onChange={(e) => setTitleColor(e.target.value)}
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group style={{ flex: 1 }}>
                <Form.Label>
                  <b className="text-sm-start">{kTrans("")}&nbsp;</b>
                </Form.Label>
                <DropdownButton
                  className="customDropdown w-30 standard-dropdown"
                  id="titleFontSize"
                  title={pxOptions.find((p) => p === titleFontSize) ?? "N/A"}
                >
                  {pxOptions.map((option) => (
                    <Dropdown.Item
                      key={option}
                      eventKey={option}
                      onClick={() => setTitleFontSize(option)}
                    >
                      {option}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Form.Group>
            </div>

            <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
              <Form.Group style={{ flex: 4 }}>
                <Form.Label>
                  <b className="text-sm-start">{kTrans("Description")}</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  id="description"
                  name="description"
                  className="w-100"
                  placeholder={kTrans("Enter a description")}
                />
              </Form.Group>

              <Form.Group style={{ flex: 1 }}>
                <Form.Label>
                  <b className="text-sm-start">{kTrans("")}&nbsp;</b>
                </Form.Label>
                <InputGroup className="w-100 color-picker-container">
                  <CustomColorPicker
                    color={descriptionColor}
                    onChange={(newColor) => setDescriptionColor(newColor)}
                  />
                  <Form.Control
                    type="text"
                    value={descriptionColor}
                    style={{ border: "0px" }}
                    onChange={(e) => setDescriptionColor(e.target.value)}
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group style={{ flex: 1 }}>
                <Form.Label>
                  <b className="text-sm-start">{kTrans("")}&nbsp;</b>
                </Form.Label>
                <DropdownButton
                  className="customDropdown w-30 standard-dropdown"
                  id="descriptionFontSize"
                  title={
                    pxOptions.find((p) => p === descriptionFontSize) ?? "N/A"
                  }
                >
                  {pxOptions.map((option) => (
                    <Dropdown.Item
                      key={option}
                      eventKey={option}
                      onClick={() => setDescriptionFontSize(option)}
                    >
                      {option}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Form.Group>
            </div>

            <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
              <Form.Group style={{ flex: 4 }}>
                <Form.Label>
                  <b className="text-sm-start">{kTrans("Button Text")}</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={buttonText}
                  onChange={(e) => setButtonText(e.target.value)}
                  id="buttonText"
                  name="buttonText"
                  className="w-100"
                  placeholder={kTrans("Enter button text")}
                />
              </Form.Group>

              <Form.Group style={{ flex: 1 }}>
                <Form.Label>
                  <b className="text-sm-start">{kTrans("")}&nbsp;</b>
                </Form.Label>
                <InputGroup className="w-100 color-picker-container">
                  <CustomColorPicker
                    color={buttonTextColor}
                    onChange={(newColor) => setButtonTextColor(newColor)}
                  />
                  <Form.Control
                    type="text"
                    value={buttonTextColor}
                    style={{ border: "0px" }}
                    onChange={(e) => setButtonTextColor(e.target.value)}
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group style={{ flex: 1 }}>
                <Form.Label>
                  <b className="text-sm-start">{kTrans("")}&nbsp;</b>
                </Form.Label>
                <DropdownButton
                  className="customDropdown w-30 standard-dropdown"
                  id="buttonFontSize"
                  title={pxOptions.find((p) => p === buttonFontSize) ?? "N/A"}
                >
                  {pxOptions.map((option) => (
                    <Dropdown.Item
                      key={option}
                      eventKey={option}
                      onClick={() => setButtonFontSize(option)}
                    >
                      {option}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Form.Group>
            </div>
            <div className="segment-form-buttons">
              <button className="blue-button" type="submit" disabled={loading}>
                Save
              </button>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
